<ngx-spinner name="upsSpinner" bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#321815" type="custom" [fullScreen]="true">
  <app-spinner></app-spinner>
</ngx-spinner>

<!-- Spinner and Dashboard Section -->
<div class="col-12">

  @if (!isLoader && !isDetailView) {
    <div class="card card-body mt-1-percent">
      <span class="list-title">Approval History</span>

      <!-- Filters -->
      <div class="filter-container col-12">
        <form [formGroup]="dateForm" class="filter-form">

          <!-- Start Date -->
          <mat-form-field id="startDate" class="filter-field">
            <mat-label>Start Date</mat-label>
            <input
              class="fs-13"
              formControlName="startDate"
              matInput
              [matDatepicker]="startDatepicker"
              [errorStateMatcher]="matcher"
              placeholder="MM/DD/YYYY"
              name="startDate" />
              <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatepicker></mat-datepicker>
              @if (dateForm.hasError('dateRangeInvalid')) {
                <mat-error
                  class="date-error">
                  Start Date should be less than End Date.
                </mat-error>
              }
            </mat-form-field>

            <!-- End Date -->
            <mat-form-field id="endDate" class="filter-field">
              <mat-label>End Date</mat-label>
              <input
                class="fs-13"
                formControlName="endDate"
                matInput
                [matDatepicker]="endDatepicker"
                [errorStateMatcher]="matcher"
                placeholder="MM/DD/YYYY"
                name="endDate" />
                <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatepicker></mat-datepicker>
                @if (dateForm.hasError('endDateRequired') && (dateForm.get('endDate')?.touched || dateForm.get('startDate')?.touched)) {
                  <mat-error
                    class="date-error">
                    End date is required when start date is provided.
                  </mat-error>
                }
                @if (dateForm.hasError('dateRangeInvalid')) {
                  <mat-error
                    class="date-error">
                    End date must be after start date.
                  </mat-error>
                }
              </mat-form-field>

              <!-- Status Filter
              <mat-form-field id="statusFilter" class="filter-field">
                <mat-label>Status</mat-label>
                <mat-select formControlName="statusFilter" name="statusFilter">
                  <mat-option value="0">All</mat-option>
                  <mat-option value="5">Approved</mat-option>
                  <mat-option value="4">Rejected</mat-option>
                  <mat-option value="3">Need More Information</mat-option>
                </mat-select>
              </mat-form-field> -->

              <!-- Apply Button -->
              <button
                type="button"
                id="btnApply"
                (click)="onSubmit()"
                class="btn btn-yellow-filled">
                <i class="fas fa-search"></i> Apply
              </button>
            </form>
          </div>

          <!-- Main Table -->
          <app-dynamictable
            [displayedColumns]="mainTableFieldMapping"
            [dataSource]="dataSource"
            (openDialog)="openAcceptOrRejectDialog($event)"
            [isFromBulkUpload]="true"
            [hideFilterAndRefresh]="true">

          </app-dynamictable>
        </div>
      }

      @if (!isLoader && isDetailView) {
        <div class="card card-body mt-1-percent">

          <!-- Back Button -->
          <div class="details-header mb-3">
            <button
              mat-flat-button
              class="custom-back-btn back-btn-colored"
              (click)="backToDashboard()">
              ← Back
            </button>
            <div class="info">
              Please use this button to navigate back to the previous history screen
            </div>
          </div>

          <!-- Detail Table -->
          <span class="list-title">Request Details</span>
          <app-dynamictable
            [displayedColumns]="detailTableFieldMapping"
            [dataSource]="invoiceDataSource"
            (openDialog)="openAcceptOrRejectDialog($event)"
            [isFromBulkUpload]="true"
            [hideFilterAndRefresh]="true">
          </app-dynamictable>
        </div>
      }
    </div>
